import { Box, Column, Grid, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import type { ReactNode } from 'react';
import { AuthBackLink } from '~/components/AuthRedesign/shared';
import { SignUpStepProgressBar, type TSignUpStep } from '../SignUpStepProgressBar';

export interface ISignUpStepWrapperProps {
  step: TSignUpStep;
  /** Destination for the "Back" link. */
  backTo: string;
  /** Page title rendered below the progress bar. */
  title: string;
  /** Optional subtitle under the title. Accepts nodes so pages can inline styled spans. */
  subtitle?: ReactNode;
  /** Step content rendered below the title block. */
  children: ReactNode;
}

const SUBTITLE_MAX_WIDTH = 710;
const TITLE_TO_SUBTITLE_GAP = 16;

export const SignUpStepWrapper = ({
  step,
  backTo,
  title,
  subtitle,
  children,
}: ISignUpStepWrapperProps) => (
  <Box data-testid="signup-step-wrapper">
    <Grid columns="1fr auto 1fr" align="center" px={6} py={6}>
      <Row align="center">
        <AuthBackLink to={backTo} />
      </Row>
      <Box style={{ marginTop: 16 }}>
        <SignUpStepProgressBar step={step} />
      </Box>
      <Box aria-hidden />
    </Grid>
    <Column align="center" pt={3} pb={24}>
      <Typography
        as="h1"
        size="heading_2"
        bold
        color={colors.neutral[600]}
        textAlign="center"
        style={{ margin: 0 }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Box
          style={{
            maxWidth: SUBTITLE_MAX_WIDTH,
            textAlign: 'center',
            marginTop: TITLE_TO_SUBTITLE_GAP,
            marginBottom: 32,
          }}
        >
          <Typography variant="body1" color={colors.neutral[500]} textAlign="center">
            {subtitle}
          </Typography>
        </Box>
      )}
      {children}
    </Column>
  </Box>
);
